export function useShowText(vehicle: uui.domain.client.UnifiedVehicle) {
  const hasIcon =
    vehicle.isPhysicalDevice && vehicle.trackingProvider === 'WWGPS' && !!vehicle.deviceIconId
  return vehicle.hasRoutingLicense || (vehicle.isPhysicalDevice && !hasIcon)
}
